import React from 'react';
import { Row, Col, } from 'antd';

import OnTraccrCheckbox from '../../../common/inputs/OnTraccrCheckbox';

export default ({
  optional,
  onChange,
  disabled,
}) => (
  <Row style={{ marginTop: 10 }} gutter={10}>
    <Col>
      <OnTraccrCheckbox
        value={disabled || optional}
        onChange={onChange}
        disabled={disabled}
        label="Optional"
        hoverNode={(
          <div style={{ width:250}}>
            Check this box to make this field <b>optional</b>.
            <br/><br/>
            Optional fields can be left blank by the user filling out the form.
          </div>
        )}
      />
    </Col>
  </Row>
);
